/**
 * Copyright Mántum All Rights Reserved.
 */
import AlertButton from './components/common/button/alert';
import ContainedButton from './components/common/button/contained';
import DropDownButton from './components/common/button/dropdown';
import TextButton from './components/common/button/text';

const Button = {
    Alert: AlertButton,
    Contained: ContainedButton,
    DropDown: DropDownButton,
    Text: TextButton
};

import TabContainer from './components/common/tab';
import TabRow from './components/common/internal/tab/row';

const Tab = {
    Container: TabContainer,
    Row: TabRow
};

import DropdownContainer from './components/common/dropdown';
import DropdownRow from './components/common/dropdown/row';
import DropdownSeparator from './components/common/dropdown/separator';

const Dropdown = {
    Container: DropdownContainer,
    Row: DropdownRow,
    Separator: DropdownSeparator
};

import NotificationContainer from './components/common/notification';
import NotificationRow from './components/common/notification/row';

const Notification = {
    Container: NotificationContainer,
    Row: NotificationRow
};

import fetcher from './adapter/fetcher';

const Adapter = {
    fetcher
};

import Active from './components/form/active';
import Autocomplete from './components/form/autocomplete';
import Checkbox from './components/form/checkbox';
import Chips from './components/form/chips';
import Color from './components/form/color';
import Currency from './components/form/currency';
import Date from './components/form/date';
import DateTime from './components/form/datetime';
import Email from './components/form/email';
import ExternalAction from './components/form/external-action';
import File from './components/form/file';
import Image from './components/form/image';
import Label from './components/form/label';
import List from './components/form/list';
import Menu from './components/common/menu';
import Message from './components/common/message';
import Modal from './components/common/modal';
import Number from './components/form/number';
import Password from './components/form/password';
import Radio from './components/form/radio';
import Search from './components/common/search';
import Section from './components/common/section';
import Select from './components/form/select';
import TermsAndConditions from './components/form/terms-and-conditions';
import Text from './components/form/text';
import Textarea from './components/form/textarea';
import Time from './components/form/time';

import Kanela from './kanela';

import useEmpty from './hooks/useEmpty';
import useEscape from './hooks/useEscape';
import useOpen from './hooks/useOpen';
import useOutside from './hooks/useOutside';
import useTimeout from './hooks/useTimeout';

import LayoutMain from './layout';
import Page from './layout/sidebar-screen/page';
import Sidebar from './layout/sidebar';

const Layout = {
    Layout: LayoutMain,
    Page,
    Sidebar
};

export {
    Active,
    Adapter,
    Autocomplete,
    Button,
    Checkbox,
    Chips,
    Color,
    Currency,
    Date,
    DateTime,
    Dropdown,
    Email,
    ExternalAction,
    File,
    Image,
    Label,
    Layout,
    List,
    Menu,
    Message,
    Modal,
    Notification,
    Number,
    Password,
    Radio,
    Search,
    Section,
    Select,
    Tab,
    TermsAndConditions,
    Text,
    Textarea,
    Time,
    useEmpty,
    useEscape,
    useOpen,
    useOutside,
    useTimeout
};

export default Kanela;
